(function() {
    'use strict';

    angular
        .module('app.memberAdmin')
        .component('sc3MemberAdmin', {
            templateUrl: 'app/member-admin/member-admin.component.html',
            controller: MemberAdminComponent,
            bindings: { member: '<' }
        });

    var noop = angular.noop,
        scoringStates = {
            "member-admin.score-history": 1,
            "member-admin.deleted-scores": 1,
            "member-admin.handicap-calculation": 1,
            "member-admin.handicap-card": 1,
            "member-admin.handicap-history": 1
        },
        profileStates = {
            "member-admin.settings": 1,
            "member-admin.membership": 1,
            "member-admin.attributes": 1,
            "member-admin.roles": 1,
            "member-admin.ign-membership": 1,
            "member-admin.integration": 1,
            "member-admin.course-list": 1
        };

    MemberAdminComponent.$inject = ['$scope', 'Member', 'toggleFriend', 'confirm', 'alert', 'memberAdminResources', '$state', 'user', 'OpenId'];
    function MemberAdminComponent($scope, Member, toggleFriend, confirm, alert, resources, $state, user, OpenId) {
        var ctrl = this;
        Object.defineProperty(ctrl, 'isScoringState', { get: getIsScoringState });
        Object.defineProperty(ctrl, 'isProfileState', { get: getIsProfileState });
        Object.defineProperty(ctrl, 'isNationalAdmin', { get: getIsNationalAdmin });
        Object.defineProperty(ctrl, 'canConvertNineToEighteen', { get: canConvertNineToEighteen })

        ctrl.$onInit = init;
        ctrl.refresh = refresh;
        ctrl.toggleFriend = toggleFriend;

        ctrl.requestCard = requestCard;
        ctrl.resetLowHandicap = resetLowHandicap;
        ctrl.reverseActivation = reverseActivation;
        ctrl.sendPasswordEmail = sendPasswordEmail;
        ctrl.calculateHandicap = calculateHandicap;
        ctrl.isState = isState;
        ctrl.convertNineToEighteen = convertNineToEighteen;

        ctrl.isAssociationAdmin = user.isAssociationAdmin;
        ctrl.isSystemAdmin = user.isSystemAdmin;
        ctrl.isNationalLookupAdmin = user.isNationalLookupAdmin;
        ctrl.isHandicapChair = user.isHandicapChair;
        ctrl.impersonate = impersonate;
        ctrl.checkInRBCCanadianOpenPlayer = checkInRBCCanadianOpenPlayer;
        

        //////////////////////////////////

        function init() {
            $scope.$on('$userChanged', refresh);
        }
        function refresh() {
            var member = ctrl.member,
                individualId = member.individualId,                
                clubId = member.clubId;


            Member.getProfile({ id: individualId, clubId: clubId }, success, noop);

            function success(member) {
                ctrl.member = member;
            }
        }
        function requestCard() {
            var member = ctrl.member,
                name = member.name,
                individualId = member.individualId;

            confirm(resources.requestCardConfirmation, name).then(requestCard, noop);

            function requestCard() {
                Member.requestCard({ id: individualId }, success, error, true);

                function success() {
                    alert.success(resources.requestCardSuccess);
                }
                function error() {
                    alert.error(resources.requestCardFailed, name);
                }
            }
        }

        function sendPasswordEmail() {
            var member = ctrl.member,
                name = member.name,
                email = member.email,
                individualId = member.individualId;

            confirm(resources.sendPasswordEmailConfirmation, name, email).then(sendPasswordEmail, noop);

            function sendPasswordEmail() {
                Member.sendPasswordEmail({ id: individualId }, success, error, true);

                function success() {
                    alert.success(resources.sendPasswordEmailSuccess);
                }
                function error() {
                    alert.error(resources.sendPasswordEmailFailed, name, email);
                }
            }
        }

        function resetLowHandicap() {
            var member = ctrl.member,
                name = member.name,
                individualId = member.individualId;

            confirm(resources.calculateLowHandicapConfirmation, name).then(calculateLowHandicap, noop);

            function calculateLowHandicap() {
                Member.calculateLowHandicap({ id: individualId }, success, error, true);

                function success() {
                    ctrl.refresh();
                    alert.success(resources.calculateLowHandicapSuccess);
                }
                function error() {
                    alert.error(resources.calculateLowHandciapFailed, name);
                }            
            }
        }

        function reverseActivation() {
            var member = ctrl.member,
                name = member.name,
                clubId = member.clubId,
                individualId = member.individualId;
                

            confirm(resources.reverseActivationConfirmation, name).then(reverseActivation, noop);

            function reverseActivation() {
                Member.reverseActivation({ id: individualId }, clubId, success, error, true);

                function success() {
                    ctrl.refresh();
                    alert.success(resources.reverseActivationSuccess);
                }
                function error() {
                    alert.error(resources.reverseActivationFailed, name);
                }
            }
        }


        function calculateHandicap() {
            var member = ctrl.member,
                name = member.name,                
                individualId = member.individualId;

            confirm(resources.calculateHandicapConfirmation, name).then(calculateHandicap, noop);

            function calculateHandicap() {
                Member.calculateHandicap({ id: individualId }, success, error, true);

                function success() {
                    ctrl.refresh();
                    alert.success(resources.calculateHandicapSuccess);
                }
                function error() {
                    alert.error(resources.calculateHandciapFailed, name);
                }
            }
        }
        function isState(name) {
            return $state.is(name);
        }
        function getIsScoringState() {
            return $state.current.name in scoringStates;
        }
        function getIsProfileState() {
            return $state.current.name in profileStates;
        }
        function getIsNationalAdmin() {
            return user.isNationalAdmin;
        }
        function impersonate() {
            var member = ctrl.member,
                individualId = member.individualId,
                name = member.name;

            OpenId.impersonate({ id: individualId }, success, error, true);

            function success(res) {
                window.open('login/' + res.token + '?storageType=sessionStorage', 'blank', 'menubar=1,resizable=1,width=1024,height=768');
            }

            function error() {
                alert.error(resources.impersonationFailed, name);
            }
        }  
        function checkInRBCCanadianOpenPlayer(type) {
            var member = ctrl.member,
                individualId = member.individualId,
                name = member.name;

            Member.checkInRBCCanadianOpenPlayer({ id: individualId, cardType: type }, success, error, true);

            function success() {
                alert.success(resources.checkInRBCCanadianOpenPlayerSucceeded, name).then(success, noop);

                function success() {
                    $state.go('association-admin');
                }
            }

            function error() {
                alert.error(resources.checkInRBCCanadianOpenPlayerFailed, name);
            }
        }
        function convertNineToEighteen() {
            var member = ctrl.member,
                isAssociationAdmin = ctrl.isAssociationAdmin,
                isNineHoleGolfer = member.isNineHoleGolfer,
                individualId = member.individualId;

            if (isAssociationAdmin && isNineHoleGolfer) {
                confirm(resources.convertNineToEighteenConfirm, name).then(convertNineToEighteen, noop);
            }

            function convertNineToEighteen() {
                Member.convertNineToEighteen({ id: individualId }, success, error, true);

                function success() {
                    alert.success(resources.convertNineToEighteenSuccess);
                }
                function error() {
                    alert.error(resources.convertNineToEighteenSuccessFailed);
                }
            }
        }

        function canConvertNineToEighteen() {
            var member = ctrl.member;
            return ctrl.isAssociationAdmin && member && member.isNineHoleGolfer;
        }
    }
})();